import React, { useState } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import { signInWithGoogle } from '../../App';
import googlelogo from '../Images/google.png';
import closeicon from '../Images/close.png';
import person from '../Images/person.svg';
import lock from '../Images/lock.svg';
import letter from '../Images/letter.svg';
import { index } from '../redux/index';
import {useNavigate} from "react-router-dom"



const JoinModal = ({isJoinModalVisible, setIsJoinModalVisible, setIsLoginModalVisible}) => {
    const navigate = useNavigate();
    const [nameState, setNameState] = useState('');
    const [emailState, setEmailState] = useState('');
    const [roleState, setRoleState] = useState('');
    const [passwordState, setPassword] = useState('');
    const [confirmPasswordState, setConfirmPassword] = useState('');

    const handleNameChange = (event) => {
        setNameState(event.target.value);
    };
    const handleEmailChange = (event) => {
        setEmailState(event.target.value);
    };
    const handlePasswordChange = (event) => {
        setPassword(event.target.value)
    }
    const handleConfirmPasswordChange = (event) => {
        setConfirmPassword(event.target.value)
    }
    const signUp = (event) => {
        if (confirmPasswordState === passwordState) {
            const [name, email, role, password] = [nameState, emailState, roleState, passwordState];
            firebase.auth().createUserWithEmailAndPassword(email, password)
            .then((result) => {
                index();
                firebase.firestore().collection('users')
                .doc(firebase.auth().currentUser.uid)
                .set({
                    name,
                    email,
                    role,
                    username: '',
                    image: '',
                    location: '',
                    dob: '',
                    following: 0,
                    follower: 0,
                    time: firebase.firestore.FieldValue.serverTimestamp()
                })
                .then(() => {
                    navigate('/user/new/onboard')
                })
                console.log(result)
            })
            .catch((error) => {
                console.log(error)
            })
            event.preventDefault();
        }
    }  
  return (
    <div>   
        <Modal show={isJoinModalVisible} onHide={() => {setIsJoinModalVisible(false)}}>       
            <Modal.Body>  
                <div className='modal-outer'>
                    <div className="close-icon-div">
                        <img src={closeicon} alt="Close Icon" onClick={() => setIsJoinModalVisible(false)} className="close-icon"></img>
                    </div>
                    <div className="modal-inner">
                        <h2 className="modal-header">Sign up to Cuisn</h2>
                        <button onClick={() => {signInWithGoogle(navigate)}} className="home-sign-up">
                            <img src={googlelogo} alt="Google Logo" className="google-logo"></img> 
                            <span className="google-signin">Sign up with Google</span>
                        </button>
                        <span className="modal-content">or</span>
                        <form onSubmit={signUp}>
                            <div className="signup-form">
                                <div className='name-div'>
                                    <Container className="person-container">
                                        <Row>
                                            <Col xs={1} md={1} lg={1} className="person-col">
                                                <img src={person} alt="Person Icon" className='person-icon'></img>
                                            </Col>
                                            <Col xs={11} md={11} lg={11}>
                                                <input type="text" placeholder="Name" className="name-input" value={nameState} onChange={handleNameChange} required></input>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                                <div className='email-div'>
                                    <Container className='email-container'>
                                        <Row>
                                            <Col xs={1} md={1} lg={1} className="person-col">
                                                <img src={letter} alt="Letter Icon" className='email-icon'></img>
                                            </Col>
                                            <Col xs={11} md={11} lg={11}>
                                                <input type="email" placeholder="Email" className="name-input" value={emailState} onChange={handleEmailChange} required></input>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                                <div className='password-div join-password-div'>
                                    <Container className='password-container'>
                                        <Row>
                                            <Col xs={1} md={1} lg={1} className="person-col">
                                                <img src={lock} alt="Lock Icon" className='lock-icon'></img>
                                            </Col>
                                            <Col xs={11} md={11} lg={11}>
                                                <input type="text" placeholder="Password" className="name-input" value={passwordState} onChange={handlePasswordChange} required></input>
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                                <div className='password-div join-password-div confirm-password-div'>
                                    <Container className='password-container'>
                                        <Row>
                                            <Col xs={1} md={1} lg={1} className="person-col">
                                                <img src={lock} alt="Lock Icon" className='lock-icon'></img>
                                            </Col>
                                            <Col xs={11} md={11} lg={11}>
                                                <input type="text" placeholder="Confirm Password" className="name-input confirm-password-input" value={confirmPasswordState} onChange={handleConfirmPasswordChange} required></input>
                                                {(confirmPasswordState === '') ? null: (confirmPasswordState !== passwordState) ? <span className='passwords-not-match'>Passwords don't match</span> : null}
                                            </Col>
                                        </Row>
                                    </Container>
                                </div>
                                <button className='home-sign-up email-signup' type="submit" name="submit">Sign up with email</button>
                            </div>
                        </form>
                        <div>
                            <span className="got-account">
                                Got an account already? 
                                <button onClick={() => {setIsLoginModalVisible(true); setIsJoinModalVisible(false)}} className='modal-link'>Log In</button>
                            </span>      
                        </div>
                    </div>
                </div>
            </Modal.Body>  
        </Modal>  
    </div>
  )
}

export default JoinModal